export default {
  data() {
    return {
      intelligentDistributionConfig: {
        model: 'manual',
        offers_per_consumer: 1,
        product_send_limits: [],
      },
    }
  },
  computed: {
    isIntelligentDistributionEnabled() {
      return (
        this.intelligentDistributionConfig.model === 'intelligent' ||
        (this.campaign && this.campaign.auto_distributed) ||
        (this.campanha && this.campanha.auto_distributed)
      )
    },
    offersPerConsumer() {
      return (
        this.intelligentDistributionConfig.offers_per_consumer ||
        (this.campaign && this.campaign.user_distribution_models?.[0]?.quantity) ||
        (this.campanha && this.campanha.user_distribution_models?.[0]?.quantity) ||
        5
      )
    },
  },
  watch: {
    'campaign.auto_distributed': {
      handler(newAutoDistributed) {
        if (newAutoDistributed !== undefined) {
          this.intelligentDistributionConfig.model = newAutoDistributed ? 'intelligent' : 'manual'
        }
      },
      immediate: true,
    },
    'campaign.user_distribution_models': {
      handler(newValue) {
        if (newValue && newValue.length > 0 && newValue[0].quantity) {
          const quantity = newValue[0].quantity
          if (this.intelligentDistributionConfig.offers_per_consumer !== quantity) {
            this.intelligentDistributionConfig.offers_per_consumer = quantity
          }
        }
      },
      immediate: true,
      deep: true,
    },
    'campanha.auto_distributed': {
      handler(newAutoDistributed) {
        if (newAutoDistributed !== undefined) {
          this.intelligentDistributionConfig.model = newAutoDistributed ? 'intelligent' : 'manual'
        }
      },
      immediate: true,
    },
    'campanha.user_distribution_models': {
      handler(newValue) {
        if (newValue && newValue.length > 0 && newValue[0].quantity) {
          const quantity = newValue[0].quantity
          if (this.intelligentDistributionConfig.offers_per_consumer !== quantity) {
            this.intelligentDistributionConfig.offers_per_consumer = quantity
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initializeIntelligentDistribution(campaign) {
      if (campaign.maria_campaign_config) {
        this.intelligentDistributionConfig = {
          model: campaign.maria_campaign_config.enabled ? 'intelligent' : 'manual',
          offers_per_consumer: campaign.maria_campaign_config.offers_per_consumer || 5,
          product_send_limits: campaign.maria_campaign_config.product_send_limits || [],
        }
      }
    },
    updateDistributionModel(model) {
      this.intelligentDistributionConfig.model = model
    },
    updateOffersPerConsumer(value) {
      this.intelligentDistributionConfig.offers_per_consumer = value

      if (this.campaign && this.campaign.user_distribution_models && this.campaign.user_distribution_models.length > 0) {
        this.campaign.user_distribution_models[0].quantity = value
      }
      if (this.campanha && this.campanha.user_distribution_models && this.campanha.user_distribution_models.length > 0) {
        this.campanha.user_distribution_models[0].quantity = value
      }
    },
    getDistributionModelForAPI() {
      if (this.isIntelligentDistributionEnabled) {
        return {
          model: 'REPURCHASE',
          quantity: this.offersPerConsumer,
        }
      }
      return null
    },
  },
}
